import gql from 'graphql-tag'

export default gql`query currentUserQuery {
  currentUser {
    _id
    email
    profile {
      _id
      imageUrl
      firstName
      lastName
      birthDate
      gender
      telephone
      nationality
    }
    achievements {
      _id
      reward {
        _id
        name {
          en
          th
          zh
        }
        type
        badge {
          completed
        }
      }
      createdAt
    }
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/queries/currentUser.js